import API from './api'

const getLookupData = async (type) => {
  try {
    const response = await API.get(`/Common/lookupdata/${type}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getClassData = () => getLookupData('class')
export const getSubjectData = () => getLookupData('subject')
export const getTopicData = () => getLookupData('topic')
export const getSubtopicData = () => getLookupData('sub_topic')
export const getTestTypesData = () => getLookupData('test_type')

const postLookupData = async (body) => {
  try {
    const response = await API.post('/Common/lookupdata', body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postClassData = (body) => postLookupData(body)
export const postSubjectData = (body) => postLookupData(body)
export const postTopicData = (body) => postLookupData(body)
export const postSubtopicData = (body) => postLookupData(body)
export const postTestTypesData = (body) => postLookupData(body)

export const postQuestionsData = async (body) => {
  try {
    const response = await API.post('/Teacher/questions', body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getQuestionsData = async (body) => {
  try {
    const response = await API.get('/Teacher/questions', body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postQuestionsSearch = async (body) => {
  try {
    const response = await API.post('/Teacher/questions/search', body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}
export const getQuestionsKey = async (questionKey) => {
  try {
    const response = await API.get(`/Teacher/questions/${questionKey}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const updateQuestions = async (questionKey, body) => {
  try {
    const response = await API.put(`/Teacher/questions/${questionKey}`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const deleteQuestion = async (questionKey) => {
  try {
    const response = await API.delete(`/Teacher/questions/${questionKey}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const bulkUploadQuestions = async (body) => {
  try {
    const response = await API.post('/Teacher/questions/bulkupload', body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const createTest = async (body) => {
  try {
    const response = await API.post('/Teacher/exams', body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getTestById = async (id) => {
  try {
    const response = await API.get(`/Teacher/exams/${id}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const updateTest = async (body, id) => {
  try {
    const response = await API.put(`/Teacher/exams/${id}`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const updateQuestionsTest = async (id, body) => {
  try {
    const response = await API.put(`/Teacher/exams/questions/${id}`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postExamsSearch = async (body) => {
  try {
    const response = await API.post('/Teacher/exams/search', body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const deleteTest = async (questionKey) => {
  try {
    const response = await API.delete(`/Teacher/exams/${questionKey}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getTestIntro = async (testKey) => {
  try {
    const response = await API.get(`/Teacher/taketest/intro/${testKey}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getTestQuestions = async (testKey, sno) => {
  try {
    const response = await API.get(`/Teacher/taketest/nextquestion/${testKey}/${sno}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const submitAnswers = async (testKey, body) => {
  try {
    const response = await API.put(`/Teacher/taketest/submitanswers/results/${testKey}`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const summaryAnswers = async (testKey, body) => {
  try {
    const response = await API.put(`/Teacher/taketest/submitanswers/summary/${testKey}`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const updateTestStatus = async (testKey, body) => {
  try {
    const response = await API.put(`/Teacher/exams/status/${testKey}`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getTestVerification = async (testKey) => {
  try {
    const response = await API.get(`/Teacher/exams/verify/${testKey}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postExercisesSearch = async (body) => {
  try {
    const response = await API.post('/Teacher/exercises/search', body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const createExercises = async (body) => {
  try {
    const response = await API.post('/Teacher/exercises', body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const updateExercisesQuestions = async (id, body) => {
  try {
    const response = await API.put(`/Teacher/exercises/questions/${id}`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExercisesById = async (id) => {
  try {
    const response = await API.get(`/Teacher/exercises/${id}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const updateExercises = async (body, id) => {
  try {
    const response = await API.put(`/Teacher/exercises/${id}`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const deleteExercises = async (questionKey) => {
  try {
    const response = await API.delete(`/Teacher/exercises/${questionKey}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const updateExercisesStatus = async (testKey, body) => {
  try {
    const response = await API.put(`/Teacher/exercises/status/${testKey}`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExercisesVerification = async (testKey) => {
  try {
    const response = await API.get(`/Teacher/exercises/verify/${testKey}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postQuestionsImages = async (imageData) => {
  try {
    const response = await API.post('/Teacher/questions/images', imageData)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getQuestionFilterClass = async () => {
  try {
    const response = await API.get('/teacher/questions/searchfilters/class')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getQuestionFiltersubject = async () => {
  try {
    const response = await API.get('/teacher/questions/searchfilters/subject')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getQuestionFilterTopic = async () => {
  try {
    const response = await API.get('/teacher/questions/searchfilters/topic')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getQuestionFilterSubTopic = async () => {
  try {
    const response = await API.get('/teacher/questions/searchfilters/sub_topic')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExamFilterClass = async () => {
  try {
    const response = await API.get('/teacher/exams/searchfilters/class')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExamFiltersubject = async () => {
  try {
    const response = await API.get('/teacher/exams/searchfilters/subject')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExamFilterTopic = async () => {
  try {
    const response = await API.get('/teacher/exams/searchfilters/topic')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExamFilterSubTopic = async () => {
  try {
    const response = await API.get('/teacher/exams/searchfilters/sub_topic')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExamFilterTestType = async () => {
  try {
    const response = await API.get('/teacher/exams/searchfilters/test_type')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExerciseFilterClass = async () => {
  try {
    const response = await API.get('/teacher/exercises/searchfilters/class')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExerciseFiltersubject = async () => {
  try {
    const response = await API.get('/teacher/exercises/searchfilters/subject')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExerciseFilterTopic = async () => {
  try {
    const response = await API.get('/teacher/exercises/searchfilters/topic')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExerciseFilterSubTopic = async () => {
  try {
    const response = await API.get('/teacher/exercises/searchfilters/sub_topic')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExerciseFilterTestType = async () => {
  try {
    const response = await API.get('/teacher/exercises/searchfilters/test_type')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const checkExercisesDuplicate = async (data) => {
  try {
    const response = await API.post('/teacher/exercises/checkforduplicate', data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}
export const checkExamsDuplicate = async (data) => {
  try {
    const response = await API.post('/teacher/exams/checkforduplicate', data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const auditLogTimesheet = async () => {
  try {
    const response = await API.put(`/teacher/auditlog/timesheet`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const verifyExercises = async (exerciseKey, body) => {
  try {
    const response = await API.put(`/Teacher/exercises/verify/${exerciseKey}`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const verifyTest = async (testKey, body) => {
  try {
    const response = await API.put(`/Teacher/exams/verify/${testKey}`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}
